import {
  arrayOf as arrayType,
  fragment,
  customType,
  bool as boolType,
  params,
  shape as shapeType,
  number as numberType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const categoryDataModel = {
  searchModel: params({ keyword: stringType(), navParam: stringType() }).shape({
    relatedResults: shapeType({
      visualNavs: arrayType(shapeType({
        label: stringType(),
        imageId: stringType(),
        webUrl: stringType(),
        categoryId: stringType(),
        imageURL: stringType()
      })),
      visualNavContainsEvents: boolType()
    }),
    searchReport: shapeType({
      keyword: stringType()
    }),
    dimensions: arrayType(shapeType({
      label: stringType(),
      refinements: arrayType(shapeType({
        url: stringType(),
        refinementKey: stringType(),
      }))
    }))
  })
};

export const visNavDataModel = {
  component: params({
    id: stringType()
      .isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['VisualNavigation'])
      .isRequired(),
  })
    .shape({
      VisualNavigation: fragment()
        .shape({
          id: stringType(),
          title: stringType(),
          componentName: stringType(),
          visualNavigationList: arrayType(shapeType({
            id: stringType(),
            title: stringType(),
            description: stringType(),
            link: stringType(),
            image: shapeType({
              url: stringType(),
              description: stringType(),
            }),
            previewImage: shapeType({
              damContentSelector: shapeType({
                assetData: arrayType(
                  shapeType({
                    selectedImageUrl: stringType()
                  })
                )
              }),
              damDownloadedContent: shapeType({
                url: stringType(),
              }),
            }),
            enterpriseContentModel: shapeType({
              link_cta: stringType(),
              image_siloh: shapeType({
                damDownloadedContent: shapeType({
                  id: stringType(),
                  url: stringType(),
                  description: stringType(),
                }),
              }),
              headline_LessThan40Char: stringType(),
              subhead: stringType(),
            }),
          })),
        }),
    }),
};

const simplePromotionalOfferFragment = fragment().shape({
  simpleOfferHeadline: stringType(),
  simpleOfferSubhead: stringType(),
});

const dollarOrPercentageOffPromotionalOfferFragment = fragment().shape({
  eyebrow: stringType(),
  shouldShowDollar: boolType(),
  shouldShowOff: boolType(),
  specialOfferHeadline: stringType(),
  specialOfferSubhead: stringType(),
});

export const promoVisNavDataModel = {
  component: params({
    id: stringType()
      .isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['PromoVisualNavigation'])
      .isRequired(),
  })
    .shape({
      PromoVisualNavigation: fragment()
        .shape({
          id: stringType(),
          title: stringType(),
          componentName: stringType(),
          legalCopy: shapeType({
            legalText: stringType(),
            legalUrl: stringType(),
          }),
          sectionCTAButton: shapeType({
            callToAction: stringType(),
            destinationLink: stringType()
          }),
          promoVisualNavigationList: arrayType(shapeType({
            id: stringType(),
            promotionalOffer: shapeType({
              SimplePromotionalOffer: simplePromotionalOfferFragment,
              DollarOrPercentageOffPromotionalOffer: dollarOrPercentageOffPromotionalOfferFragment,
            }),
            link: stringType(),
            previewImage: shapeType({
              damContentSelector: shapeType({
                assetData: arrayType(
                  shapeType({
                    selectedImageUrl: stringType()
                  })
                )
              }),
              damDownloadedContent: shapeType({
                url: stringType(),
              }),
            }),
            __typename: stringType(),
          })),
        }),
    }),
};